/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { LogoWrapper, breakpoints } from '@coursera/cds-core';

import { getBase64 } from 'bundles/page/lib/logo';

const SRC_PREFIX = 'data:image/svg+xml;base64,';

const styles = {
  image: css`
    height: 32px;
    width: 127px;
    ${breakpoints.down('xs')} {
      width: 108px;
    }
  `,
};

const LOGO_COLOR = '#0056D2'; // must be a valid hex color for getBase64 to work

const CourseraHomeLogo = ({ logoColor = LOGO_COLOR }: { logoColor?: string }) => {
  const imgSrc = SRC_PREFIX + getBase64(logoColor);

  // We don't need to translate company name.
  // eslint-disable-next-line no-restricted-syntax
  return (
    <LogoWrapper size="small">
      <img css={styles.image} src={imgSrc} alt="Coursera" />
    </LogoWrapper>
  );
};

export default CourseraHomeLogo;
